import React from 'react'

import { GrowthFiguresInt } from '../../constants/GrowthFigures'

import './growth-figures.css'

export interface LatestRefefinanceIndexProps {
  growthFigureData: GrowthFiguresInt
  indexDetailType: string
  isAvailable: boolean
}

export const LatestRefefinanceIndex: React.FC<LatestRefefinanceIndexProps> = ({
  growthFigureData,
  indexDetailType,
  isAvailable,
}) => {
  return (
    <div className="latest-index-container">
      {isAvailable ? (
        <div className="index-figures">
          <div className="latest-index-details">
            <div className="latest-index-text">LATEST REFINANCE {indexDetailType} INDEX:</div>
          </div>
          <div className="latest-index-details-figure">
            {growthFigureData.refi_index !== null ? growthFigureData.refi_index.toFixed(1) : '-.-'}
          </div>
        </div>
      ) : (
        <div className="index-multiple">
          <p className="latest-index-details">Multiple datasets selected</p>
          <p className="latest-index-details-unavailable">
            Make a single selection to view the latest index figures, or tap the chart to view specific dates.
          </p>
        </div>
      )}
    </div>
  )
}
